import { SearchOutlined } from "@ant-design/icons";
import type { TimeRangePickerProps } from "antd";
import { Button, DatePicker, Input, Modal, Popover } from "antd";
import arLocale from "antd/es/date-picker/locale/ar_EG";
import enLocale from "antd/es/date-picker/locale/en_US";
import dayjs from "dayjs";
import "dayjs/locale/ar";
import { useState } from "react";
import { useIntl } from "react-intl";
import { exportIcon, filterSVG } from "../../assets/SVGs/SVGs";
import FilterForm from "../admin/common/FilterForm";
import ExportModal from "../clients/ExportModal";
type props = {};
const HeadTableSales = ({
  setIsFilter,
  data,
  handelChangeDates,
  title,
  setSearchClient,
  searchClient,
  filterType,
  dateRange,
}: any) => {
  const [exportModal, setExportModal] = useState(false);
  const { locale } = useIntl();
  const searching = (e: string) => {
    console.log(e);
    setSearchClient(e);
  };
  const intl = useIntl();
  const showExportModal = () => {
    setExportModal(true);
  };
  const closeExport = () => {
    setExportModal(false);
  };

  const rangePresets: TimeRangePickerProps["presets"] = [
    {
      label: intl.formatMessage({
        id: "Last7Days",
      }),
      value: [dayjs().subtract(7, "d"), dayjs()],
    }, // Last 7 days
    {
      label: intl.formatMessage({
        id: "Last14Days",
      }),
      value: [dayjs().subtract(14, "d"), dayjs()],
    }, // Last 14 days
    {
      label: intl.formatMessage({
        id: "Last30Days",
      }),
      value: [dayjs().subtract(30, "d"), dayjs()],
    }, // Last 30 days
    {
      label: intl.formatMessage({
        id: "Last90Days",
      }),
      value: [dayjs().subtract(90, "d"), dayjs()],
    }, // Last 90 days
  ];
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };
  return (
    <>
      <Modal
        width="60%"
        centered
        open={exportModal}
        onCancel={closeExport}
        className="max-md:min-w-[350px]"
        footer={null}
      >
        <ExportModal close={closeExport} data={data} title={title} />
      </Modal>
      <div className="flex items-center justify-between gap-5">
        <div className="flex items-center w-1/2 gap-4 max-md:w-1/6 max-md:flex-col HeaderSales">
          <div
            onClick={showExportModal}
            className="border-[1px] border-solid border-[#9999A7] w-fit px-3 py-2 flex items-center rounded-lg cursor-pointer bg-white"
          >
            {exportIcon}
          </div>
          <Popover
            content={
              <FilterForm
                setIsFilter={setIsFilter}
                filterType={filterType}
                setOpen={setOpen}
              />
            }
            title={false}
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
            placement="bottom"
          >
            <Button className="flex items-center justify-center p-1 px-3 bg-white rounded-lg border-[#9999A7] !max-h-[36px] hover:!bg-white">
              {filterSVG}
            </Button>
          </Popover>
        </div>

        <div className="flex items-center order-1 w-full gap-3 max-md:flex-col ">
          <DatePicker.RangePicker
            locale={locale === "ar" ? arLocale : enLocale}
            presets={[
              {
                label: (
                  <span aria-label="Current Time to End of Day">
                    {intl.formatMessage({
                      id: "day",
                    })}
                  </span>
                ),
                value: () => [dayjs(), dayjs().endOf("day")], // 5.8.0+ support function
              },
              ...rangePresets,
            ]}
            value={[
              dateRange.from ? dayjs(dateRange.from) : null,
              dateRange.to ? dayjs(dateRange.to) : null,
            ]}
            placeholder={[
              intl.formatMessage({
                id: "start",
              }),
              intl.formatMessage({
                id: "end",
              }),
            ]}
            className="!w-full"
            onChange={(rangeDate) => handelChangeDates(rangeDate)}
          />
          <Input
            size="small"
            placeholder={intl.formatMessage({
              id: "placeholderInputSales",
            })}
            className="w-full h-full p-2 rounded-lg"
            value={searchClient}
            onChange={(e) => searching(e.target.value)}
            suffix={
              <SearchOutlined
                style={{
                  color: "#9999A7",
                  position: "absolute",
                  right: 8,
                  top: 12,
                }}
              />
            }
            style={{ paddingRight: 30 }}
          />
        </div>
      </div>
    </>
  );
};

export default HeadTableSales;
